import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "dashboardData", "customer", "month", "year", "monthBlock", "yearBlock" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update") || document.body.getAttribute("data-action").includes("edit_account") || document.body.getAttribute("data-action").includes("update_account")) {
      var cleavePhone = new Cleave('.input-phone', {
        phone: true,
        phoneRegionCode: 'br'
      })
    }
    if (document.body.getAttribute("data-action").includes("reports")) {
      this.monthBlockTarget.classList.add("is-display-none")
      this.yearBlockTarget.classList.add("is-display-none")
    }
  }
}
